document.addEventListener("DOMContentLoaded", function () {
  const customSelect = document.querySelector(".custom-select");
  const select = document.querySelector(".sort_by");
  const trigger = document.querySelector(".custom-select__trigger span");
  const options = document.querySelectorAll(".custom-select__option");

  // Function to get URL parameter value
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  // Check for sort_by parameter in the URL
  const sortByValue = getUrlParameter("sort_by");

  let initialValue = null; // Keep track of the initial selected value

  // First, check for sort_by parameter in the URL
  if (sortByValue) {
      const selectedOption = document.querySelector(
          `.custom-select__option[data-value="${sortByValue}"]`
      );

      if (selectedOption) {
          initialValue = sortByValue;
          trigger.textContent = selectedOption.textContent;
          select.value = sortByValue;

          options.forEach((opt) => opt.classList.remove("selected"));
          selectedOption.classList.add("selected");
      }
  }

  // If no URL parameter, or if the parameter is invalid, use the first option
  if (!initialValue && options.length > 0) {
      initialValue = options[0].dataset.value;
      trigger.textContent = options[0].textContent;
      select.value = options[0].dataset.value;

      options.forEach((opt) => opt.classList.remove("selected"));
      options[0].classList.add("selected");
  } else if (!initialValue) {
      trigger.textContent = "No options available";
      select.value = "";
  }

  customSelect.addEventListener("click", function () {
    this.classList.toggle("open");
  });

  options.forEach((option) => {
    option.addEventListener("click", function () {
      const value = this.dataset.value;
      select.value = value;
      trigger.textContent = this.textContent; // Set the selected option's text

      options.forEach((opt) => opt.classList.remove("selected"));
      this.classList.add("selected");

      select.dispatchEvent(new Event("change"));

      customSelect.classList.remove("open");
    });
  });

  // Listen for changes on the hidden select
  select.addEventListener("change", function () {
    const selectedValue = this.value;
    const selectedOption = document.querySelector(
      `.custom-select__option[data-value="${selectedValue}"]`
    );

    if (selectedOption) {
      trigger.textContent = selectedOption.textContent; // Update text on change

      // Update selected class
      options.forEach((opt) => opt.classList.remove("selected"));
      selectedOption.classList.add("selected");
    }
  });

  /* close the button */
  const filterButton = document.querySelector('.popout__toggle');
  const sidebar = document.querySelector('.sorting-wrapper .sidebar'); // Ensure this selector is correct
  const sidebarCloseButton = document.querySelector('[data-collection-sidebar-close]');
  const sortingWrapper = document.querySelector('.sorting-wrapper'); // The main container

  if (!filterButton || !sidebar || !sidebarCloseButton || !sortingWrapper) {
    console.warn('One or more elements not found. Check your selectors.');
    return; // Exit if required elements are missing
  }

  // Function to toggle the 'expanded' class
  const toggleSidebar = () => {
    sortingWrapper.classList.toggle('expanded');  // Added on parent element
  };

  // Open/Close the sidebar on button click
  filterButton.addEventListener('click', toggleSidebar);

  // Close the sidebar on close button click
  sidebarCloseButton.addEventListener('click', (event) => {
    event.preventDefault(); // Prevent the link from navigating
    sortingWrapper.classList.remove('expanded');  //Removed on parent element
  });

  // Close the sidebar on outside click
  document.addEventListener('click', (event) => {
    if (!sortingWrapper.contains(event.target) && sortingWrapper.classList.contains('expanded')) {
      sortingWrapper.classList.remove('expanded'); // Removed on parent element
    }
  });

  // Prevent clicks *within* the sidebar from triggering the outside click handler
  sidebar.addEventListener('click', (event) => {
    event.stopPropagation(); // Stop the event from bubbling up to the document
  });

});